import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { ScrollRestoration, useLocation, useNavigate } from 'react-router';

import { useAppSelector } from '../store/hooks';

function BaseLayout({
  children,
  isAuthLayout,
}: PropsWithChildren<{ isAuthLayout?: boolean }>) {
  const user = useAppSelector((state) => state.user);
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const currentPath = pathname + search;

  const isUserAuthorized = user.authorized;
  const isUserLoading = user.loading;

  useEffect(() => {
    if (isUserLoading) {
      return;
    }

    let url: string;
    if (
      pathname === '/' ||
      pathname === '/auth/login' ||
      pathname.startsWith('/error_description')
    ) {
      url = '/auth/login';
    } else {
      url = `/auth/login?redirectTo=${currentPath}`;
    }

    // redirect to login page if we're not authorized and not on login page
    if (!isAuthLayout && !isUserAuthorized) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises -- react-router v7 upgrade
      navigate(url, { replace: true });
    } else if (pathname === '/') {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises -- react-router v7 upgrade
      navigate('/dashboard', { replace: true });
    }
  }, [
    navigate,
    isUserAuthorized,
    isUserLoading,
    isAuthLayout,
    currentPath,
    pathname,
  ]);

  return (
    <>
      <Helmet
        titleTemplate="%s | Blue Yonder - Logistics Emissions Calculator - Admin"
        title="Blue Yonder - Logistics Emissions Calculator - Admin"
      />
      <ScrollRestoration />
      {children}
    </>
  );
}

export { BaseLayout };
